import { Dayjs } from "dayjs"

export enum ThrottleEventStatus {
  ACTIVE = "ACTIVE",
  RESUMED = "RESUMED",
  DISCARDED = "DISCARDED",
}

export interface IThrottleEvent {
  id: number
  communicationName: string
  windowStart: Dayjs
  windowSeconds: number
  maxPerWindow: number
  emailsSent: number
  emailsThrottled: number
  status: ThrottleEventStatus
  resumedBy: string | null
  resumedAt: Dayjs | undefined
  discardedBy: string | null
  discardedAt: Dayjs | undefined
}
